/*
The name of the role that is put in a auth token to indicate that the user is ezyreg verified.
*/
export const EzyregVerified = 'EZYREG_VERIFIED';
